import React, { useId } from 'react';
import './ProgressIndicator.scss';

interface ProgressIndicatorProps {
  start?: string;
  end?: string;
  value: number;
  label?: string;
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({
  value = 0,
  start = '0%',
  end = '100%',
  label
}) => {
  const id = useId();

  return (
    <div className="mss-progress-indicator">
      <span className="mss-progress-indicator__container">
        <span
          className="mss-progress-indicator__progress"
          style={{ width: `${value}%` }}
          aria-describedby={`${id}-label`}
        ></span>
      </span>
      <div className="mss-progress-indicator__labels">
        <span>{start}</span>
        <span id={`${id}-label`}>{label}</span>
        <span>{end}</span>
      </div>
    </div>
  );
};

export default ProgressIndicator;
